export default __webpack_public_path__ + "static/media/svg-2.590f3bcc.svg";